import Vue from "vue";

export default {
	state: {
		suppliers: []
	},
	mutations: {
		setSuppliersExpiredRequirementOnState(state, suppliers) {
			state.suppliers = suppliers;
		},
		setExpiredRequirementOnSupplier(state, expiredRequirementBySupplier) {
			let supplier = state.suppliers.find((a) => a.idSupplier == expiredRequirementBySupplier.idSupplier);
			Vue.set(supplier, "requirement", expiredRequirementBySupplier.expiredRequirements);
		}
	},
	actions: {
		getSuppliersExpiredRequirements({ commit }) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("/supplier/ExpiredRequirement")
					.then((response) => {
						this.state.loading = false;
						commit("setSuppliersExpiredRequirementOnState", response.data.data);
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getExpiredRequirements({ commit }, idSupplier) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("/ExpiredRequirement/" + idSupplier)
					.then((response) => {
						this.state.loading = false;
						let expiredRequirementBySupplier = {
							idSupplier: idSupplier,
							expiredRequirements: response.data.data
						};
						commit("setExpiredRequirementOnSupplier", expiredRequirementBySupplier);
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		}
	},
	getters: {
		suppliers({ suppliers }) {
			return suppliers;
		},
		expiredRequirements({ expiredRequirements }) {
			return expiredRequirements;
		}
	}
};
